// Template registry
import defaultTemplate from './default/index.js'
import { defaultTemplateParams } from './default/params.js'
import defaultPreview from './default/preview.jpg'
import defaultCardImage from './default/template.png'
import twoColumnTemplate from './twoColumn/index.js'
import { defaultTemplateParams as twoColumnTemplateParams } from './twoColumn/params.js'
import twoColumnPreview from './twoColumn/preview.jpg'
import twoColumnCardImage from './twoColumn/template.png'

// Available templates configuration
export const availableTemplates = {
  default: {
    name: 'Default Template',
    description: 'Clean and modern email template with hero image',
    template: defaultTemplate,
    params: defaultTemplateParams,
    preview: defaultPreview,
    cardImage: defaultCardImage
  },
  twoColumn: {
    name: 'Two Column Template',
    description: 'Two column layout for better content organization',
    template: twoColumnTemplate,
    params: twoColumnTemplateParams,
    preview: twoColumnPreview,
    cardImage: twoColumnCardImage
  }
}

// Get template by name
export const getTemplate = (templateName = 'default') => {
  return availableTemplates[templateName] || availableTemplates.default
}

// Get all template names
export const getTemplateNames = () => {
  return Object.keys(availableTemplates)
}

// Get template list for gallery
export const getTemplateOptions = () => {
  return Object.entries(availableTemplates).map(([key, template]) => ({
    value: key,
    label: template.name,
    description: template.description,
    preview: template.preview,
    cardImage: template.cardImage
  }))
}
